const Button = ({ children, color, item, ...rest }) => {
  return (
    <button className={`bg-${color}-400 hover:bg-${color}-500 text-white font-bold py-2 px-4 rounded mr-2 mb-2`} {...rest}>
      {children}
    </button>
  )
}

export {Button}